import BaseService from '@/services/BaseService';

class GeneralInfoService extends BaseService {
    getGeneralInfo = () => this.get('/get-general-info');

    addGeneralInfo = (data) => this.post('/add-general-info', data);
}

export default new GeneralInfoService();
